module.exports = {
    props: ['user', 'team'],

    /**
     * The component's data.
     */
    data() {
        return {
            form: new SparkForm({
                encircle_token: ''
            })
        };
    },


    /**
     * Prepare the component.
     */
    mounted() {
        this.form.encircle_token = this.team.encircle_token;
    },


    methods: {
        /**
         * Update the team name.
         */
        update() {
            Spark.put(`/settings/${Spark.teamsPrefix}/${this.team.id}/encircle-token`, this.form)
                .then(() => {
                    Bus.$emit('updateTeam');
                });
        }
    }
};
